import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, } from 'antd';
import PackageAdd from './PackageAdd';
import { useBnsBaoZhuangDelMutation, useBnsBaoZhuangListQuery } from '../../store/ReactWebSiteApi';
import PackageEdit from './PackageEdit';
import ModalDel from '../../cpn/ModalDel';
import PackageCheck from './PackageCheck';
function PackageList() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsBaoZhuangListQuery({bbz_e_id:localStorage.getItem('e_id')},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bbz_id:key,bbz_name,bbz_ctime,bbz_cname,bbz_content,bbz_dept_id,bbz_dept_name,bbz_type_name,bbz_bg_name} = item;
                    return item = {key,bbz_name,bbz_ctime,bbz_cname,bbz_content,bbz_dept_id,bbz_dept_name,bbz_type_name,bbz_bg_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bbz_ctime;
                    let bTimeString = b.bbz_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'list',
            title: '推广方案名称',
            render:(_,record) => {
                return  <PackageCheck 
                            bbz_name={record.bbz_name}
                            bbz_content={record.bbz_content}
                            bbz_id={record.key}
                            bbz_dept_id={record.bbz_dept_id}
                            bbz_dept_name={record.bbz_dept_name}
                            bbz_type_name={record.bbz_type_name}
                        />
            }            
        },     
        {
            key: 'bbz_type_name',
            title: '产品',            
            dataIndex:'bbz_bg_name',
        },
        {
            key: 'bbz_type_name',
            title: '平台',            
            dataIndex: 'bbz_type_name',
            
        },
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
            
        },
        {
            key: 'bbz_dept_name',
            title: '部门',            
            dataIndex: 'bbz_dept_name',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bbz_ctime + record.bbz_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <PackageEdit
                            bbz_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({bbz_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />   
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsBaoZhuangDelMutation()
    return (
        <Main t1='推广'  t2='推广方案'>
            <Space size='large'>
                <PackageAdd />             
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default PackageList